import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { setApiBase } from './api';
import './styles/widget.css';

Sentry.init({
  dsn: 'https://84055c8f600b7818d20a19753b3c5589@o61198.ingest.us.sentry.io/4511229587947520',
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
});

// The same legacy widget bundle is served by every instance (kaktus, chello,
// veronadue, vox, ...). Tag each event with the instance so errors can be
// filtered/grouped per-restaurant in Sentry — otherwise they're indistinguishable.
function deriveInstance(host: string): string {
  const sub = host.replace(/\.hallochef\.(net|dev|hr)$/i, '').replace(/^www\./i, '');
  const parts = sub.split(/[.-]/).filter((p) => p && p !== 'online' && p !== 'widget');
  return parts[0] || host;
}
Sentry.setTag('instance', deriveInstance(window.location.hostname));
Sentry.setTag('widget_host', window.location.hostname);

// Read API base from the script tag's data attribute, or default to same-origin
const scriptTag = document.querySelector('script[data-api]');
if (scriptTag) {
  setApiBase(scriptTag.getAttribute('data-api') || '');
}

const container = document.getElementById('hallochef-widget');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Došlo je do greške. Molimo osvježite stranicu.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>
  );
}
